import { OptionType } from '@fullstory/components';
import { ObjectType } from '@fullstory/proto/fs/services/dx-objects';
import { SpaceActionType } from '../../types';
import React from 'react';
import { SpaceObjectModal } from '../../components';
import { useDefaultSpaceSelectOption, useSpacesEnabled } from '../../hooks';

interface SpaceObjectModalContainerProps {
  onCloseSignal: () => void;
  open: boolean;
  onSave: () => void;
  objectType: ObjectType;
  objectOwningSpaceId: string;
  selectedSpace: OptionType<string> | null;
  onSpaceSelect: (option: OptionType<string> | null) => void;
  spaceOptions: OptionType<string>[];
  selectedSection: OptionType<string> | null;
  onSectionSelect: (option: OptionType<string> | null) => void;
  sectionRequired: boolean;
  sectionOptions: OptionType<string>[] | null;
  keepReference: boolean;
  onKeepReferenceChange: (keepReference: boolean) => void;
  mode: SpaceActionType;
}

export const SpaceObjectModalContainer: React.FC<SpaceObjectModalContainerProps> = ({
  open,
  objectType,
  objectOwningSpaceId,
  spaceOptions,
  selectedSpace,
  onSpaceSelect,
  mode,
  ...rest
}) => {
  const { hasSpacesFeaturePack } = useSpacesEnabled();
  useDefaultSpaceSelectOption(
    open,
    objectType,
    objectOwningSpaceId,
    selectedSpace,
    spaceOptions,
    onSpaceSelect,
    mode,
  );

  return (
    <SpaceObjectModal
      open={open}
      objectType={objectType}
      spaceOptions={spaceOptions}
      selectedSpace={selectedSpace}
      onSpaceSelect={onSpaceSelect}
      mode={mode}
      disableSpaceSelect={!hasSpacesFeaturePack}
      {...rest}
    />
  );
};
SpaceObjectModalContainer.displayName = 'SpaceObjectModalContainer';
